import { createSelector } from 'reselect';

export const decisionsSelector = state => state.decisions;

export const hasDecisionsSelector = createSelector(
  decisionsSelector,
  decisions => Object.keys(decisions).length > 0
);
